/**
 * Wellness marketplace constants — categories + countries + currency.
 * Kept in sync with /app/backend/wellness_routes.py WELLNESS_CATEGORIES.
 */
import {
  Leaf, Barbell, PersonSimpleTaiChi, HandHeart, Brain, Sun, Plant,
} from '@phosphor-icons/react';

export const WELLNESS_CATEGORIES = [
  {
    id: 'nutrition', name: 'Nutrition', icon: Leaf, color: '#10B981',
    tint: 'from-emerald-50 to-emerald-100', accent: 'text-emerald-700',
    tagline: 'Personalized nutrition guidance',
    types: ['Nutritionist', 'Registered Dietitian', 'Sports Nutritionist', 'Clinical Nutritionist', 'Weight Management Professional'],
  },
  {
    id: 'fitness', name: 'Fitness', icon: Barbell, color: '#EA580C',
    tint: 'from-orange-50 to-orange-100', accent: 'text-orange-700',
    tagline: 'Trainers &amp; coaches for real results',
    types: ['Personal Trainer', 'Fitness Coach', 'Strength & Conditioning Coach', 'Sports Coach', 'Mobility Coach'],
  },
  {
    id: 'yoga', name: 'Yoga & Mindfulness', icon: PersonSimpleTaiChi, color: '#7C3AED',
    tint: 'from-violet-50 to-violet-100', accent: 'text-violet-700',
    tagline: 'Yoga, pilates, meditation & breathwork',
    types: ['Yoga Trainer', 'Pilates Instructor', 'Meditation Coach', 'Breathwork Coach'],
  },
  {
    id: 'recovery', name: 'Recovery', icon: HandHeart, color: '#0EA5E9',
    tint: 'from-sky-50 to-sky-100', accent: 'text-sky-700',
    tagline: 'Physio & sports therapy specialists',
    types: ['Physiotherapist', 'Sports Therapist', 'Mobility Specialist'],
  },
  {
    id: 'mental', name: 'Mental Wellness', icon: Brain, color: '#EC4899',
    tint: 'from-pink-50 to-pink-100', accent: 'text-pink-700',
    tagline: 'Counselling & stress management',
    types: ['Psychologist', 'Counsellor', 'Stress Management Professional'],
  },
  {
    id: 'lifestyle', name: 'Lifestyle', icon: Sun, color: '#F59E0B',
    tint: 'from-amber-50 to-amber-100', accent: 'text-amber-700',
    tagline: 'Sleep, habit & lifestyle coaching',
    types: ['Sleep Coach', 'Habit Coach', 'Lifestyle Coach'],
  },
  {
    id: 'holistic', name: 'Holistic Wellness', icon: Plant, color: '#65A30D',
    tint: 'from-lime-50 to-lime-100', accent: 'text-lime-700',
    tagline: 'Ayurveda &amp; naturopathy',
    types: ['Ayurveda Practitioner', 'Naturopathy Practitioner'],
  },
];

export const MODES = [
  { id: 'online', label: 'Online', short: 'Online' },
  { id: 'in_person', label: 'In-person', short: 'In-person' },
  { id: 'home_visit', label: 'Home Visit', short: 'Home' },
];

export const COUNTRIES = [
  { code: 'IN', name: 'India', currency: 'INR' },
  { code: 'US', name: 'United States', currency: 'USD' },
  { code: 'CA', name: 'Canada', currency: 'CAD' },
  { code: 'GB', name: 'United Kingdom', currency: 'GBP' },
  { code: 'AU', name: 'Australia', currency: 'AUD' },
  { code: 'AE', name: 'United Arab Emirates', currency: 'AED' },
  { code: 'SG', name: 'Singapore', currency: 'SGD' },
  { code: 'DE', name: 'Germany', currency: 'EUR' },
  { code: 'FR', name: 'France', currency: 'EUR' },
];

export const LANGUAGES = ['English', 'Hindi', 'Spanish', 'French', 'Arabic', 'German', 'Mandarin', 'Japanese', 'Portuguese', 'Italian'];

export const CURRENCY_SYMBOLS = {
  INR: '₹', USD: '$', CAD: 'C$', GBP: '£', AUD: 'A$',
  AED: 'AED ', SGD: 'S$', EUR: '€',
};

export const formatPrice = (amount, currency = 'USD') => {
  const symbol = CURRENCY_SYMBOLS[currency] || `${currency} `;
  const rounded = Number(amount).toLocaleString('en-US', { maximumFractionDigits: 2 });
  // Some currencies use trailing space; keep single leading symbol
  return `${symbol}${rounded}`;
};

export const getCategoryById = (id) => WELLNESS_CATEGORIES.find((c) => c.id === id);
export const getCountryByCode = (code) => COUNTRIES.find((c) => c.code === (code || '').toUpperCase());
